import finitalia from "./finitalia/images";
import linear from "./linear/images";
import unipol from "./unipol/images";
import cai from "./cai/images";
import unipol_meteo from "./unipol_meteo/images";
import defaults from "./default/images";

export default {default: defaults, unipol, linear, finitalia, cai, unipol_meteo};
